import { StudentTeacher } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getStudentTeachers(studentNo: string) {
    try {
        const response = await portalApi.get<StudentTeacher[]>(`/students/${studentNo}/teachers`);
        return response.data
    } catch (error) {
        console.error("Error fetching student teachers:", error);
        throw error;
    }
}
